import axios from 'axios';

export const resAuthorize = async (url) => {
  return axios.post(
    url + 'authorize',
    {},
    {
      headers: {
        accept: 'application/json',
        'x-3ds-api-key': '78a19f216d26440892cca3d031e62e20',
      },
    }
  );
};
